import { useEffect } from "react";
import { processNetworkFromUrl, processTokensFromUrl, URL_KEYS } from "../utils/urlUtils";
import { useSwitchNetwork } from "wagmi";
import { GlobalStore } from "../store/global/GlobalStore";
import { cloneDeep } from "lodash-es";
import { getTokens } from "../store/global/getTokenMetadata";
import * as Sentry from "@sentry/browser";

export function useUrlNetworkParams() {
  const params = new URLSearchParams(window.location.search);
  const network = params.get(URL_KEYS.NETWORK);
  const from = params.get(URL_KEYS.FROM);
  const to = params.get(URL_KEYS.TO);
  const { switchNetwork } = useSwitchNetwork();
  const tokenMetadata = GlobalStore.useState(s => s.tokens);
  const currentNetwork = GlobalStore.useState(s => s.network);
  useEffect(() => {
    const networkMatch = processNetworkFromUrl(network);
    if (networkMatch && switchNetwork && networkMatch.name !== currentNetwork.name) {
      switchNetwork(networkMatch.id);
    } else if (networkMatch && networkMatch.name !== currentNetwork.name) {
      getTokens(networkMatch.name, false)
        .then(tokens => {
          GlobalStore.update(s => {
            s.tokens = tokens ?? {};
            s.network = cloneDeep(networkMatch) as typeof s.network;
          });
        })
        .catch(e => {
          Sentry.captureException(
            `Could not get tokens while switching chain. Switching chain without new tokens`,
            { extra: { event: e } }
          );
          GlobalStore.update(s => {
            s.network = cloneDeep(networkMatch) as typeof s.network;
          });
        });
    }

    if (tokenMetadata) {
      processTokensFromUrl(from, to, tokenMetadata);
    }
  }, [currentNetwork, from, network, switchNetwork, to, tokenMetadata]);
}
